export default {
  methods: {
    confirmAlert(
      message = `Are you sure you want to submit your changes? Before you submit, be sure all your requirement are accurate.`,
      confirmButtonText = "Yes, Submit it!"
    ) {
      return this.$swal({
        // title: "Are you sure you want to submit the changes?",
        text: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#f5365c",
        confirmButtonText: confirmButtonText
      });
    }
  }
};
